import { useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { routes } from 'app/routes';
import { AlertsContext } from 'pkg/Alerts/index';
import { HttpError } from 'pkg/httpClient/httpClient';

const REDIRECT_TO_MAIN_PAGE_ERROR_CODE = '422';

export const useHttpErrorAlert = () => {
  const { setError } = useContext(AlertsContext);
  const history = useHistory();

  return useCallback(
    (error: HttpError) => {
      if (error.errorMessages.some(({ errorCode }) => errorCode === REDIRECT_TO_MAIN_PAGE_ERROR_CODE)) {
        history.push(routes.INSTANT_QUOTE);
      }
      setError(error.errorMessages.map(({ errorMessage }) => errorMessage));
    },
    [setError, history]
  );
};
